import React from 'react';
import laytonLogo from '../assets/layton-logo.svg';
import nineAndDineLogo from '../assets/nine-and-dine-logo.svg';

const EventCard = ({ event, onRSVP, distanceMi }) => {
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    });
  };

  const currentRSVPs = event.currentRSVPs || 0;
  const capacity = event.capacity || 1;
  const isFull = currentRSVPs >= capacity;
  const fillPct = Math.min((currentRSVPs / capacity) * 100, 100);
  const spotsLeft = capacity - currentRSVPs;

  const getCapacityColor = () => {
    if (fillPct >= 90) return '#c9302c';
    if (fillPct >= 70) return '#e8a43c';
    return 'var(--primary)';
  };

  const isPrizePool = event.prizePool === true;
  const feeLabel = event.feeLabel || `$${event.fee} per person`;

  return (
    <div className="event-card">
      <div className="event-image-wrap">
        {event.imageUrl ? (
          <img src={event.imageUrl} alt={event.title} className="event-image" />
        ) : (
          <div className="event-image-placeholder">
            <img src={laytonLogo} alt="Layton" className="event-placeholder-logo" />
          </div>
        )}
        <div className="event-image-overlay" />
        {!event.comingSoon && event.date && <span className="event-date-badge">{formatDate(event.date)}</span>}
        {isFull && !event.comingSoon && <span className="event-full-ribbon">Full</span>}
        {event.comingSoon && <span className="event-coming-soon-ribbon">Coming Soon</span>}
        {isPrizePool && !isFull && (
          <span className="event-prize-badge">🏆 Winner Takes the Pot</span>
        )}
      </div>

      <div className="event-content">
        <h2 className="event-title">{event.title}</h2>
        <div className="event-nine-dine-logo-wrap">
          <img src={nineAndDineLogo} alt="Nine &amp; Dine" className="event-nine-dine-logo" />
        </div>

        {event.isCharity && (
          <div className="event-charity-banner">
            <span className="event-charity-icon">❤️</span>
            <div className="event-charity-text">
              <span className="event-charity-label">Charity Event</span>
              <span className="event-charity-sub">
                100% of proceeds go to <strong>{event.charityName || '5 For The Fight'}</strong>
              </span>
            </div>
          </div>
        )}

        <p className="event-description">{event.description}</p>

        <div className="event-details">
          <div className="detail-item">
            <span className="detail-icon">🕐</span>
            <span>{event.time}</span>
          </div>
          <div className="detail-item">
            <span className="detail-icon">📍</span>
            <span>
              {event.location}
              {distanceMi != null && (
                <span className="event-distance"> · {distanceMi < 50 ? `${Math.round(distanceMi)} mi away` : `${Math.round(distanceMi / 100) * 100}+ mi`}</span>
              )}
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-icon">💰</span>
            <span>{feeLabel}</span>
          </div>
        </div>

        <div className="event-capacity">
          <div className="event-capacity-header">
            <span className="event-capacity-label">Spots Filled</span>
            <span className="event-capacity-count" style={{ color: getCapacityColor() }}>
              {isFull ? 'Full' : `${spotsLeft} left`}
            </span>
          </div>
          <div className="event-capacity-track">
            <div
              className="event-capacity-fill"
              style={{ width: `${fillPct}%`, background: getCapacityColor() }}
            />
          </div>
          <div className="event-capacity-sub">{currentRSVPs} / {capacity} registered</div>
        </div>

        <button
          className={`rsvp-button${event.comingSoon ? ' rsvp-coming-soon' : ''}`}
          onClick={() => !event.comingSoon && onRSVP(event)}
          disabled={isFull || event.comingSoon}
        >
          {event.comingSoon ? '🔔 Coming Soon' : isFull ? 'Event Full' : isPrizePool ? 'Enter to Win →' : 'RSVP Now →'}
        </button>
      </div>
    </div>
  );
};

export default EventCard;
